import { usePageNameContext } from "@stadium/shared/page-name-provider";

import Button from "@sharedComponents/buttons";

import { getDefaultBuildYourOwnShopNumber } from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { MOMENTS } from "@constants/routes";
import { ALL_TEMPLATES } from "@constants/templates-listing";

import { getCreateNewShopRoute } from "@stadium/helpers/app-routes";

import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import styles from "./purge-main.module.scss";

const defaultObj = {};

export const BuildYourOwnTemplateCta = ({ onTemplateSelect, buildYourOwnShopNumber }) => {
  const pageName = usePageNameContext();
  const { workspaceSlug } = useWorkspaceContext();

  if (pageName === MOMENTS) return null;

  const createShopUrl = getCreateNewShopRoute({
    shopNumber: buildYourOwnShopNumber,
    workspaceSlug,
  });

  return (
    <Button
      onClick={() => onTemplateSelect(createShopUrl, true)}
      styleType="primary"
      title="BUILD MY OWN"
      className={styles.myOwnBtn}
    >
      BUILD MY OWN
    </Button>
  );
};

const AllTemplatesHeader = ({
  setIsGridView,
  isGridView,
  currentCategory,
  onTemplateSelect = () => {},
}) => {
  const { name } = currentCategory || defaultObj;
  const buildYourOwnShopNumber = useConfig(getDefaultBuildYourOwnShopNumber);
  const pageName = usePageNameContext();
  const DEFAULT_SECTION_TITLE = `${pageName === MOMENTS ? "Moment" : "Template"} Gallery`;
  return (
    <>
      <div className={styles.templateSectionTitle}>
        {name && name !== ALL_TEMPLATES ? name : DEFAULT_SECTION_TITLE}
      </div>
      <div className={styles.templateSectionHeaderViewsBlock}>
        <div className={styles.templateSectionHeaderIconsBlock}>
          <span
            className={`${styles.templateSectionHeaderIcons} ${styles.iconGrid} ${
              isGridView ? styles.active : ""
            }`}
            onClick={() => setIsGridView(true)}
          />
          <span
            className={`${styles.templateSectionHeaderIcons} ${styles.iconMenu} ${
              !isGridView ? styles.active : ""
            }`}
            onClick={() => setIsGridView(false)}
          />
        </div>

        <div className={styles.templateSectionHeaderCtaBlock}>
          <BuildYourOwnTemplateCta
            onTemplateSelect={onTemplateSelect}
            buildYourOwnShopNumber={buildYourOwnShopNumber}
          />
        </div>
      </div>
    </>
  );
};

export default AllTemplatesHeader;
